import { render } from "./ColoredButton.vue?vue&type=template&id=9bf18d74"
import script from "./ColoredButton.vue?vue&type=script&lang=js"
export * from "./ColoredButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-auth/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__